import React from 'react';
import { ReactComponent as TreeMap } from 'assets/icons/tree-map.svg';

export const EmptyState: React.FC<Props | any> = (props: Props) => {
  const { isLoading } = props;
  return (
    <div className="empty-state">
      {!isLoading && (
        <>
          <div className="empty-state-icon">
            <TreeMap />
          </div>
          <div className="empty-state-title">There is no response selected</div>
          <div className="empty-state-description">
            Select a company from the list to view their responses, plans and
            contacts
          </div>
        </>
      )}
    </div>
  );
};

type ownProps = {
  allResponsesReceived: any;
  enquiryId: number;
  isSmallScreen: boolean;
  shareId?: string;
  responsesExpired: boolean;
  isLoading: boolean;
};

type Props = ownProps;

EmptyState.displayName = 'EmptyState';

export default React.memo(EmptyState);
